/**
 * Handles the redirect back from the backend after a magic-link click or
 * dev-login: /auth/callback?token=<jwt>. Mirrors the minimal part of
 * memoneo's frontend/src/pages/AuthCallback.tsx — store the token, then
 * navigate home once the auth context has picked it up.
 */
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { PageLayout, MutedText } from "../components/ui";
import { useAuth } from "../lib/auth";

export default function AuthCallback() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { refreshMe, setAuthenticated } = useAuth();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const token = params.get("token");
    if (token) {
      localStorage.setItem("jwt", token);
      setAuthenticated();
      void refreshMe().then(() => setReady(true));
    } else {
      navigate("/login", { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (ready) navigate("/", { replace: true });
  }, [ready, navigate]);

  return (
    <PageLayout>
      <div className="flex items-center justify-center min-h-screen">
        <MutedText>{t("authFlow.signingIn")}</MutedText>
      </div>
    </PageLayout>
  );
}
